module.exports = __webpack_public_path__ + "img/metal.43c1a846.png";